import { render, staticRenderFns } from "./studentinfo-addstudent-dialog.vue?vue&type=template&id=097fa176&scoped=true"
import script from "./studentinfo-addstudent-dialog.vue?vue&type=script&lang=js"
export * from "./studentinfo-addstudent-dialog.vue?vue&type=script&lang=js"
import style0 from "./studentinfo-addstudent-dialog.vue?vue&type=style&index=0&id=097fa176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097fa176",
  null
  
)

export default component.exports